import { z } from 'zod';
/** Envelope every error response uses. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        /** Serbian, user-facing, safe to render directly. */
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
export const healthSchema = z.object({
    ok: z.boolean(),
    version: z.string(),
    /** 'up' once a trivial query has actually round-tripped to Postgres. */
    db: z.enum(['up', 'down']),
    uptimeSec: z.number(),
    now: z.string(),
});
//# sourceMappingURL=api.js.map